import data from './en-import.json';

const translations = {
    en: {
        ...data,
    },
};

export default translations;
